// frontend/modules/loan-disbursement/index.ts
import { ModuleConfig } from '@/core/module';
import { loanDisbursementRoutes } from './routes';
import { useLoanDisbursementStore } from './stores/loan-disbursement-store';
import { PendingDisbursements } from './components/dashboard';

// Export components and hooks for external use
export { PendingDisbursements } from './components/dashboard';
export { useLoanDisbursement } from './hooks/useLoanDisbursement';

export const LoanDisbursementModule: ModuleConfig = {
    name: 'loan-disbursement',
    routes: loanDisbursementRoutes,
    stores: {
        loanDisbursement: useLoanDisbursementStore
    },
    // dashboardComponents: {
    //     PendingDisbursements
    // },
    initialize: () => {
        console.log('Loan Disbursement module initialized');
    },
    cleanup: () => {
        console.log('Loan Disbursement module cleaned up');
    }
};
